import {
    initialRuleFormValues,
    RuleComponents,
    ruleEditorTitles,
    RuleForm,
    ruleFormFields,
    ruleValidatedForms,
    ruleValidation,
} from '@innovatm/js-rule-editor';
import { FormikErrors } from 'formik';
import * as React from 'react';
import { ComponentProps } from 'react';

import { IRuleGeneric } from '../../../backend';
import * as ResourceManager from './ResourceManagerRule';
import { initialValues as initialValues1 } from './ResourceManagerRule.utils';

export const typeLabels: { value: string; label: string }[] = [
    { value: 'Rule', label: 'Simple Rule' },
    {
        value: 'NonEditableRule',
        label: 'Complex Rule',
    },
    { value: 'ResourceManagerRule', label: 'ResourceManager Rule' },
];

export const editorTitles: Record<IRuleGeneric['type'], React.ReactNode> = {
    ...ruleEditorTitles,
    ResourceManagerRule: ResourceManager.EditorTitle,
};

export const initialValues: Record<IRuleGeneric['type'], IRuleGeneric> = {
    ...initialRuleFormValues,
    ResourceManagerRule: initialValues1,
};

export const formFields: Record<IRuleGeneric['type'], React.ReactNode> = {
    ...ruleFormFields,
    ResourceManagerRule: ResourceManager.FormFields,
};

export const validation: Partial<
    Record<IRuleGeneric['type'], (options: any) => (values: IRuleGeneric) => Promise<FormikErrors<any>>>
> = {
    ...ruleValidation,
    ResourceManagerRule: RuleComponents.validateForm,
};

export const validatedForms: Partial<Record<IRuleGeneric['type'], React.FC<ComponentProps<typeof RuleForm>>>> = {
    ...ruleValidatedForms,
    ResourceManagerRule: RuleComponents.ValidatedForm,
};
